import React, { Component, useState } from "react";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal, MsalContext  } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import Button from "react-bootstrap/Button";
import { ProfileData } from "../components/ProfileData";
import { callMsGraph } from "../graph";

export class Home extends Component {
  static displayName = Home.name;
  static contextType = MsalContext;


  render() {
    document.title = "Home:ImmucertUI";

    return (
      <>
        <h1>Welcome to Immucert Admin App</h1>
        <UnauthenticatedTemplate>
          <p>You are not signed in! Please sign in.</p>
        </UnauthenticatedTemplate>
        <p>From here you can search certificate request log entries as received by immucert and view the contents of the entry as well as generate the certificate from the request. This app is subject to HIPAA restrictions.</p>
        <p>When searching for a patient record, you must always enter a state registry code, as searches will not span across state authorities.  You can search by <i>partial name</i>, or <i>full name</i>.  Name searches are case insensitive.  Additionally you can search by <i>patient dob</i> and the <i>certificate date</i>.  Or if you have a request id, you can search by the id.</p>
        <AuthenticatedTemplate>
          <ProfileContent />
        </AuthenticatedTemplate>
      </>
    );
  }
}

function ProfileContent() {
  const { instance, accounts } = useMsal();
  const [graphData, setGraphData] = useState(null);

  const name = accounts[0] && accounts[0].name;

  function RequestProfileData() {
    const request = {
      ...loginRequest,
      account: accounts[0]
    };

    // Silently acquires an access token which is then attached to a request for Microsoft Graph data
    instance.acquireTokenSilent(request).then((response) => {
      callMsGraph(response.accessToken).then(response => setGraphData(response));
    }).catch((e) => {
      instance.acquireTokenPopup(request).then((response) => {
        callMsGraph(response.accessToken).then(response => setGraphData(response));
      });
    });
  }

  return (
    <>
      <h5 className="card-title">Welcome {name}</h5>
      {graphData ?
        <ProfileData graphData={graphData} />
        :
        <Button variant="secondary" onClick={RequestProfileData}>Request Profile Information</Button>
      }
    </>
  );
};